document.addEventListener('DOMContentLoaded', () => {
const target = document.getElementById('main-collection-filters');
const rootStyles = getComputedStyle(document.documentElement);
const headerHeight = parseInt(rootStyles.getPropertyValue('--header-height'), 10);
const originalOffsetTop = target.offsetTop;
function debounce(fn, delay) {
  let timeoutId;
  return function () {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(fn, delay);
  };
}

function handleScroll() {
  const scrollY = window.scrollY || window.pageYOffset;

  if (scrollY + headerHeight >= originalOffsetTop) {
    target.classList.add('fixed-position');
  } else {
    target.classList.remove('fixed-position');
  }
}

window.addEventListener('scroll', debounce(handleScroll, 10));
});